/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'header-logo.scss' instead.
import { css } from 'lit';
export default css `@media (max-width:1199.98px){:host{height:54px!important}:host img{height:54px!important}}@media (min-width:1200px){:host img{max-height:66px;max-width:192px}}:host picture{display:flex}`;
//# sourceMappingURL=header-logo.scss.js.map